import React, { useEffect, useState, useCallback } from "react";
import "./Trending.css";
import Trending1 from "../../assets/trending/trending1.jpg";
import TrendingCard from "./TrendingCard";
import { API_BASE_URL, API_KEY } from "../../config.js";
import LoadingAnim from "../../components/LoadingAnim.jsx";
import { useTranslation } from "react-i18next";

const ITEMS_PER_PAGE = 10;

const Trending = ({ setTrendingDataExists }) => {
  // Receive the function
  const { t } = useTranslation();
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchProperties = useCallback(async () => {
    try {
      setLoading(true);
      const initData = window.Telegram.WebApp.initData;
      const response = await fetch(
        `${API_BASE_URL}/user/api/v1/most_reserved_house/?page=${page}&page_size=${ITEMS_PER_PAGE}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": API_KEY,
            "X-Telegram-InitData": initData,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const data = await response.json();
      const totalItems = data.count;

      const formattedData = data.results.map((house) => ({
        id: house.id,
        name: house.title,
        price: house.price + house.unit + " / day",
        rating: house.postedBy.rating,
        postedBy:
          house.postedBy?.userAccount?.first_name +
          " " +
          house.postedBy?.userAccount?.last_name,
        location: house.city + " " + house.specificAddress,
        amenities: house.sub_description,
        images: house.houseImage?.map((img) => img.image) || [Trending1],
      }));

      setProperties((prevProperties) => [...prevProperties, ...formattedData]);
      setTotalPages(Math.ceil(totalItems / ITEMS_PER_PAGE));
      setError(null); 

      
      setTrendingDataExists(totalItems > 0);
    } catch (error) {
      setError(error.message);
      setProperties([]); 
      setTotalPages(1); 
      // Call the function to update the state in CategoryList - set to false
      setTrendingDataExists(false);
    } finally {
      setLoading(false);
    }
  }, [page, setTrendingDataExists]); 

  useEffect(() => {
    fetchProperties();
  }, [fetchProperties]);

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop >=
        document.documentElement.offsetHeight - 100
      ) {
        if (!loading && page < totalPages) {
          setPage((prevPage) => prevPage + 1);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [loading, page, totalPages]);

  return (
    <>
      {error ? (
        <div className="text-red-500">
          {t("Error fetching trending data:")} {error}
        </div>
      ) : loading ? (
        <div className="flex justify-center items-center w-full h-full">
          <LoadingAnim />
        </div>
      ) : properties.length > 0 ? (
        <div className="overflow-x-auto flex space-x-4 p-4">
          {properties.map((property, index) => (
            <TrendingCard key={index} property={property} />
          ))}
        </div>
      ) : null}
    </>
  );
};

export default Trending;